import React from "react";
import PropTypes from "prop-types";
import { range } from "cxa-utils";
import { InputField } from "../../FormField";

const AdditionalRemarks = ({ data }) => (
  <fieldset>
    <h3>
      {
        'ADDITIONAL REMARKS: If any of the above answers is "Yes", please give full details in the space provided below'
      }
    </h3>
    <table>
      <tbody>
        <tr>
          <td width="10%" className="text--center">
            Qn No.
          </td>
          <td width="25%" className="text--center">
            Name of Insured
          </td>
          <td width="65%" className="text--center">
            Please provide date of consultation, details of diagnosis/exact condition, result, name
            and address of doctor seen
          </td>
        </tr>

        {range(1, 8).map(number => {
          const MoreInfoSubQNo = `MoreInfoSubQNo${number}`;
          const MoreInfoName = `MoreInfoName${number}`;
          const MoreInfoDiagnosis = `MoreInfoDiagnosis${number}`;

          return (
            <tr key={number}>
              <td>
                <InputField name={MoreInfoSubQNo} {...data[MoreInfoSubQNo]} />
              </td>

              <td>
                <InputField name={MoreInfoName} {...data[MoreInfoName]} />
              </td>

              <td>
                <InputField name={MoreInfoDiagnosis} {...data[MoreInfoDiagnosis]} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </fieldset>
);

AdditionalRemarks.propTypes = {
  data: PropTypes.object,
};

export default AdditionalRemarks;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/AdditionalRemarks.jsx